import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagContasPagarResponse, CreateTagContasPagarResponse } from '../../responses/financas/tag-contas-pagar.response';
import { TagFinanceiraRequest } from '../../requests/financas/tag-financeira.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagContasPagarService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'TagContasPagar';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagContasPagarResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagContasPagarResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagContasPagarResponse> {
        const url = `${this.apiUrl}/idTagContasPagar/${id}`;
        return this.httpClient
            .get<CreateTagContasPagarResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagFinanceiraRequest): Observable<CreateTagContasPagarResponse> {
        return this.httpClient
            .post<CreateTagContasPagarResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagFinanceiraRequest): Observable<CreateTagContasPagarResponse> {
        const url = `${this.apiUrl}/idTagContasPagar/${id}`;
        return this.httpClient
            .put<CreateTagContasPagarResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagContasPagar/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
